import React from "react";
import MDBox from "shared/ui/Box/MDBox";
import MDTypography from "shared/ui/Typography/MDTypography";
import PropTypes from "prop-types";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

export default function ExerciseCard({ exercise, style = {} }) {
  return (
    <MDBox
      sx={{
        width: "100%",
        boxSizing: "border-box",

        padding: "10px 14px",
        borderRadius: "8px",

        backgroundColor: "grey.100",
        border: "1px solid",
        borderColor: "grey.300",

        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "8px",

        cursor: "grab",
        userSelect: "none",
        transition: "background-color 0.15s ease, border-color 0.15s ease",

        "&:hover": {
          backgroundColor: "grey.200",
          borderColor: "grey.400",
        },
      }}
      style={{
        ...style,
        transform: "none",
      }}
    >
      <DragIndicatorIcon
        sx={{
          fontSize: "18px",
          color: "text.disabled",
          flexShrink: 0,
          cursor: "grab",
        }}
      />

      <MDTypography
        sx={{
          flex: 1,
          fontSize: "0.85rem",
          fontWeight: 500, // más suave que 600
          color: "text.primary",
          lineHeight: 1.3,
          letterSpacing: "-0.15px",

          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        {exercise.name}
      </MDTypography>
    </MDBox>
  );
}

ExerciseCard.propTypes = {
  exercise: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
  }).isRequired,
  style: PropTypes.object,
};
